import { DropdownControl, DropdownOptions, FormCol, FormRow, useScopedSelector } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Constants from '../../../../../Constants';
import { DocumentsState } from '../../../../../interfaces/DocumentsState';
import getCurrentPeriod from '../../../../../utils/getCurrentPeriod';
import getGroupedContractsPeriodIsDisplayable from '../../DocumentListGroup/GroupedContracts/GroupedContract/getGroupedContractsPeriodIsDisplayable';
import useDropdownDefaultValue from '../hooks/useDropdownDefaultValue';

export interface DocumentPeriodRowProps { }

const DocumentPeriodRow: FC<DocumentPeriodRowProps> = () => {
  const { t } = useTranslation('Documents');
  const documentGroups = useScopedSelector((state: DocumentsState) => state.groups || []);

  const periodsOptions = useMemo(() => {
    const selectAllOption = {
      value: 'SELECT_ALL',
      label: t('periodAll'),
    };
    const currentPeriodOption = {
      value: 'CURRENT',
      label: getCurrentPeriod(documentGroups),
    };
    return [currentPeriodOption, selectAllOption, ...documentGroups.filter((d) => getGroupedContractsPeriodIsDisplayable(d, documentGroups, true)).map((g) => ({
      label: g.period,
      value: g.period,
    }))];
  }, [documentGroups, t]);

  let defaultValue = useDropdownDefaultValue(Constants.DefaultPeriodParam, periodsOptions as DropdownOptions<string>);
  if (!defaultValue) defaultValue = 'SELECT_ALL';

  return (
    <FormRow>
      <FormCol label={t('period')}>
        <DropdownControl
          name="period"
          required
          options={periodsOptions}
          defaultValue={defaultValue}
        />
      </FormCol>
    </FormRow>
  );
};
export default DocumentPeriodRow;
